import React from "react";

import { AVAILABLE_COUNTRIES, AVAILABLE_LANGS } from "@typings/globals";

import { Container } from "@components/Layout/Container";
import { Section } from "@components/Layout/Section";

import * as Styled from "./Bento.styled";
import { Bento8x4_2 } from "./Bento8x4_2";
import { Bento4x4x4 } from "./Bento4x4x4";
import { Bento12 } from "./Bento12";

interface Props {
  language: AVAILABLE_LANGS;
  country: AVAILABLE_COUNTRIES;
}

export const Bento: React.FC<Props> = props => {
  return (
    <Section
      backgroundColor="white"
      bolt={{
        variant: "left",
        color: "blue500",
      }}
    >
      <Container>
        <Styled.Root>
          <Bento8x4_2 language={props.language} country={props.country} />
          <Bento4x4x4 language={props.language} />
          <Bento12 />
        </Styled.Root>
      </Container>
    </Section>
  );
};
